// ============================================================
//  Admin-side API key for /api/*.php write endpoints.
// ------------------------------------------------------------
//  This value must match `admin_api_key` in /public/api/config.php
//  on the Hostinger deployment.
//
//  ⚠ This constant ships in the compiled JS bundle. Anyone who inspects
//  the site can read it. That's acceptable for News + Video endpoints
//  because they only manage non-financial display content, and only the
//  role-gated Admin panel exposes UI for using it. Do NOT reuse this
//  key for endpoints that touch tokens, wallets, or user data.
//
//  To rotate: update `admin_api_key` in api/config.php AND change this
//  value. Rebuild + redeploy the frontend.
// ============================================================
export const ADMIN_API_KEY = '0xBf6596a279172D330b8b732D257Ee633B6FDA911';
